import { Layout } from 'components';
import { Stack } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';

export const ContainerStyled = styled(Stack)(({ theme }) => ({
  minHeight: '100%',
  backgroundColor: theme.palette.body,
}));

export const LoginLayoutStyled = styled(Layout)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  zIndex: 2,
  flex: 1,

  [theme.breakpoints.up('tablet')]: {
    minWidth: 648,
    maxWidth: 648,
  },

  '.login-content': {
    flex: 1,
    justifyContent: 'center',
    [theme.breakpoints.down('tablet')]: {
      maxWidth: 440,
      width: '100%',
      margin: '0 auto',
      justifyContent: 'flex-start',
      marginTop: 32,
    } as CSSObject,
  },
}));
